export default "__VITE_ASSET__5454c032__"